import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { get, isEqual, isEmpty } from "lodash";
import { MediaRequestContext } from "../../context/MediaRequestContext";
import MediaRequestTable from "./MediaRequestTable";
import "../../styles/media-search.scss";
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import { CREATE_MEDIA } from "../../constants/CreateMediaRequest";
import { ASSET_TYPE } from "../../constants/MediaSearch";
import MediaRequestSeasonTable from "./MediaRequestSeasonTable";
import { PageErrorContent } from "../page-error/PageError";

const MediaRequestGrid = () => {
  const history = useHistory();
  const {
    selectedOption,
    _setSelectedFiles,
    _setTransferRegion,
    _setRenamedFilename,
    _setRequestName,
    _setActiveStep,
    odsEditsData,
    recordType,
    idType,
    isPromoLoading,
    promoError,
  } = useContext(MediaRequestContext);
  const selectedOptionLabel =
    recordType === "episode"
      ? get(selectedOption, "payload.seasonTitle", get(selectedOption, "payload.title", ""))
      : get(selectedOption, "payload.title", "");

  const isEditsSelected =
    !!Object.keys(odsEditsData).length &&
    Object.keys(odsEditsData).find((idKey) =>
      odsEditsData[idKey].some(({ node }) =>
        node?.relationships?.some((relationship) =>
          relationship?.relatedEntityManifestations.some(
            (manifestation) => manifestation.isChecked
          )
        )
      )
    ) != null;

  return (
    <>
      {selectedOptionLabel && recordType !== "dmiTitle" && recordType !== ASSET_TYPE.CANTEMO && (
        <>
          <div className="media-request-grid">
            <p className="media-request-grid-title">{selectedOptionLabel}</p>
            <span>
              {isEditsSelected && !isEqual(idType, ["pavi", "pafi"]) && (
                <StyledBlueButton
                  className="media-new-request-button"
                  onClick={() => {
                    _setRequestName("");
                    _setSelectedFiles({});
                    _setTransferRegion({});
                    _setRenamedFilename({});
                    _setActiveStep(0);
                    history.push(CREATE_MEDIA.route);
                  }}
                >
                  New Request
                </StyledBlueButton>
              )}
            </span>
          </div>
          {recordType === "series" && <MediaRequestSeasonTable />}
          {recordType !== "series" && recordType !== "dmiTitle" && recordType !== ASSET_TYPE.CANTEMO && !isEqual(idType, ["pavi", "pafi"]) && !isEqual(idType, ["dmicid"]) && !isEqual(idType, ["cantemofocusid"]) && !isEqual(idType, ["dmititleid"]) && !isEqual(idType, ["bimcid"]) && <MediaRequestTable />}
        </>
      )}
      {(recordType === ASSET_TYPE.CANTEMO ||
        isEqual(idType, ["pavi", "pafi"]) ||
        isEqual(idType, ["dmicid"]) ||
        isEqual(idType, ["cantemofocusid"]) ||
        isEqual(idType, ["dmititleid"]) ||
        isEqual(idType, ["bimcid"])) && (
        <div className="hbo-promo">
          {isPromoLoading && (
            <div>
              <CircularProgress size={35} />
            </div>
          )}
          {!isPromoLoading && !isEmpty(promoError) && (
            <div className="hbo-promo-error">
              <PageErrorContent
                title={promoError["title"]}
                message={promoError["message"]}
                reloadBtn={false}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default MediaRequestGrid;
